var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew360Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1483.68 1468.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5555f9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M828.24,270.87c0,306.51,248.48,555,555,555a553.32,553.32,0,0,0,95-8.24,749.05,749.05,0,0,0,5.5-90.51c0-356.14-251-653.62-585.7-725.33A552,552,0,0,0,828.24,270.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.81,825.85c306.51,0,555-248.47,555-555A551.86,551.86,0,0,0,594.05,0C255.15,68.52,0,368,0,727.1A748.93,748.93,0,0,0,5.32,816,555.94,555.94,0,0,0,109.81,825.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M742,786.72c-268.84,0-492.74,191.25-543.77,445.06,135.47,145.86,328.88,237.16,543.64,237.16s408.37-91.39,543.85-237.37C1234.58,977.87,1010.73,786.72,742,786.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew360Logo);
export default __webpack_public_path__ + "static/media/new360Logo.3b9d08679184e7c1da473e6113aba6d7.svg";
export { ForwardRef as ReactComponent };